import React from "react";
import style from "../../style/Pages/Help/NavigationHelp.module.css";
import { Link } from "react-router-dom";
import { FiNavigation } from "react-icons/fi";
import { TbArrowLeft } from "react-icons/tb";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const NavigationHelp = () => {
  return (
    <>
      <SecondaryLayout>
        <div className={style.accountHelpWrapper}>
          <Link to="/help" className={style.backLink}>
            <TbArrowLeft className={style.backIcon} /> Back to Help Center
          </Link>

          <div className={style.header}>
            <FiNavigation className={style.headerIcon} />
            <h1>Navigation</h1>
          </div>

          <div className={style.content}>
            <p>
              The <strong>Navigation</strong> sidebar helps you explore the
              entire chat application with ease. Here's a breakdown of each
              section:
            </p>

            <h2>🏠 Home</h2>
            <ul>
              <li>
                Start from your dashboard with access to recent activity and
                updates.
              </li>
              <li>See highlights, pinned chats, and quick links.</li>
            </ul>

            <h2>💬 DMs (Direct Messages)</h2>
            <ul>
              <li>
                View all your one-on-one conversations in a dedicated section.
              </li>
              <li>
                Start a new private message or continue existing ones easily.
              </li>
            </ul>

            <h2>🔔 Activity</h2>
            <ul>
              <li>
                Stay informed with real-time notifications for mentions,
                reactions, and more.
              </li>
              <li>
                Jump directly to important messages using the activity feed.
              </li>
            </ul>

            <h2>⋯ More Menu</h2>
            <ul>
              <li>
                Expand to access extra sections like users, groups, channels,
                and settings.
              </li>
              <li>
                Ideal for managing administrative and customization features.
              </li>
            </ul>

            <h2>🧩 Key Sections Under “More”</h2>
            <ul>
              <li>
                <strong>User List</strong>: View and manage all users in the
                system.
              </li>
              <li>
                <strong>Groups</strong>: Create and organize teams or interest
                groups.
              </li>
              <li>
                <strong>Channel</strong>: Public or private chat spaces for
                structured communication.
              </li>
              <li>
                <strong>User and Role</strong>: Assign roles and permissions to
                users.
              </li>
              <li>
                <strong>Logs</strong>: Track actions and system changes for
                auditing.
              </li>
              <li>
                <strong>Companies</strong>: Manage multiple company environments
                if enabled.
              </li>
              <li>
                <strong>Appearance</strong>: Customize UI themes and layout
                preferences.
              </li>
              <li>
                <strong>About</strong>: Learn about the app version and details.
              </li>
              <li>
                <strong>Notification</strong>: Control sound alerts and
                notification settings.
              </li>
            </ul>

            <p>
              Use the sidebar to move swiftly between features and keep your
              workspace organized and productive.
            </p>
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default NavigationHelp;
